import chefGarnishingMeatPlate from "../../../assets/chef-garnishing-pasta.jpg";
import chefIsCookingSetOfAppetizers from "../../../assets/chif_selecting_ingredients.jpg";
import chefPreparesStirFryVegetables from "../../../assets/a-chef-preparing-food.JPG";

const GallerySection = ({t}) => {
    return (
        <section className="w-full bg-[#FFF] py-8 mt-5">
            <div className="container mx-auto px-4 max-w-[1200px]">
                <div className="flex flex-col md:flex-row gap-4 justify-around">
                    <div className="w-full md:w-1/3 lg:w-[30%] mb-4 md:mb-0">
                        <img
                            src={chefGarnishingMeatPlate}
                            alt="Chef garnishing meat plate"
                            width={1333}
                            height={2000}
                            className="w-full h-[300px] md:h-[400px] lg:h-[500px] object-cover transform -translate-y-[10%]"
                        />
                    </div>
                    <div className="w-full md:w-1/3 lg:w-[30%] mb-4 md:mb-0">
                        <img
                            src={chefIsCookingSetOfAppetizers}
                            alt="Chef is cooking set of appetizers"
                            width={1200}
                            height={1800}
                            className="w-full h-[300px] md:h-[400px] lg:h-[500px] object-cover transform -translate-y-[5%]"
                        />
                    </div>
                    <div className="w-full md:w-1/3 lg:w-[30%]">
                        <img
                            src={chefPreparesStirFryVegetables}
                            alt="A chef in black gloves prepares stir fry vegetables. Concept of cooking healthy organic food"
                            width={1211}
                            height={1820}
                            className="w-full h-[300px] md:h-[400px] lg:h-[500px] object-cover"
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default GallerySection;
